import React, { ChangeEvent, useState, } from "react"
import Icon from "../../common/icon/icon.component.jsx"

type Props = {
    placeholder: string,
    value: string,
    inputName: string,
    handleFormChange: (e: ChangeEvent<HTMLInputElement>) => void
}

function PasswordInput(props: Props) {
    const [inputElement, setInputElement] = useState({ type: "password", icon: "eye-slash" })

    const changeVisibility = () => {
        if (inputElement.type == "password") {
            setInputElement({ type: "text", icon: "eye" })
        } else {
            setInputElement({ type: "password", icon: "eye-slash" })
        }
    }
    return (<div className="input-group">
        <input
            name={props.inputName}
            value={props.value}
            onChange={props.handleFormChange}
            id={props.inputName}
            type={inputElement.type}
            autoComplete={"new-password"}
            className="form-control py-2 border-right-0 border"
            placeholder={props.placeholder}
        />
        <span className="input-group-append">
            <button className="btn btn-outline-secondary border-left-0 border" onClick={() => changeVisibility()} type="button">
                <Icon value={inputElement.icon}></Icon>
            </button>
        </span>
    </div>)
}

export default PasswordInput


// WEBPACK FOOTER //
// ./src/user/form/PasswordInput.tsx